import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Check, Star } from 'lucide-react';
interface Plan {
  id: 'standard' | 'premium';
  name: string;
  description: string;
  price: number;
  anchorPrice: number;
  url: string;
  badge?: string;
  savings?: string;
}
interface PlanSelectorProps {
  anchorStandard: number;
  anchorPremium: number;
}
export function PlanSelector({
  anchorStandard,
  anchorPremium
}: PlanSelectorProps) {
  const plans: Plan[] = [{
    id: 'standard',
    name: 'MÁS ALLÁ DE LA VOLUNTAD',
    description: '6 volúmenes + 6 bonos estratégicos',
    price: 19990,
    anchorPrice: anchorStandard,
    url: 'https://checkout.ideahubdigital.online/cart/48818975375579:1'
  }, {
    id: 'premium',
    name: 'PACK PREMIUM',
    description: '6 volúmenes + 6 bonos + Volúmenes 7 y 8 Premium',
    price: 29990,
    anchorPrice: anchorPremium,
    url: 'https://checkout.ideahubdigital.online/cart/48818977079515:1',
    badge: '⭐ MÁS ELEGIDO',
    savings: 'AHORRÁS $10.000'
  }];
  const [selected, setSelected] = useState<'standard' | 'premium'>('premium');
  const selectedPlan = plans.find(p => p.id === selected)!;
  return <div data-id="element-195">
      <div className="grid grid-cols-2 gap-3 md:gap-6 mb-5 md:mb-8" data-id="element-196">
        {plans.map(plan => {
        const isSelected = selected === plan.id;
        const isPremium = plan.id === 'premium';
        return <motion.button key={plan.id} type="button" onClick={() => setSelected(plan.id)} whileTap={{
          scale: 0.98
        }} className={`relative text-left rounded-xl p-3 md:p-6 shadow-md transition-all duration-300 ${isSelected ? isPremium ? 'bg-cream-light border-2 md:border-4 border-gold shadow-xl' : 'bg-cream-light border-2 md:border-4 border-navy-dark shadow-xl' : 'bg-white border-2 border-gray-200 opacity-75 hover:opacity-100'}`} data-id="element-197">
              {isPremium && <div className={`absolute -top-2.5 md:-top-4 left-1/2 -translate-x-1/2 ${isSelected ? 'bg-gold' : 'bg-gray-400'} text-navy-dark px-2 md:px-5 py-0.5 md:py-2 rounded-full font-bold text-[9px] md:text-sm whitespace-nowrap transition-colors`} data-id="element-198">
                  {plan.badge}
                </div>}

              {isPremium && plan.savings && <div className={`absolute -top-2 md:-top-3 right-1 md:right-3 ${isSelected ? 'bg-red-600' : 'bg-gray-400'} text-white px-1.5 md:px-3 py-0.5 rounded-full font-bold text-[8px] md:text-xs transition-colors`} data-id="element-199">
                  {plan.savings}
                </div>}

              <div className={`absolute top-2 md:top-3 right-2 md:right-3 w-4 h-4 md:w-5 md:h-5 rounded-full border-2 flex items-center justify-center transition-colors ${isSelected ? isPremium ? 'bg-gold border-gold' : 'bg-navy-dark border-navy-dark' : 'bg-white border-gray-300'} ${isPremium ? 'top-3 md:top-6' : ''}`} data-id="element-200">
                {isSelected && <Check className={`w-3 h-3 md:w-3.5 md:h-3.5 ${isPremium ? 'text-navy-dark' : 'text-white'}`} strokeWidth={3} data-id="element-201" />}
              </div>

              <div className={`${isPremium ? 'mt-2 md:mt-3' : ''}`} data-id="element-202">
                <h3 className="font-bold text-xs md:text-lg text-navy-dark mb-1 pr-6 md:pr-8 leading-tight" data-id="element-203">
                  {plan.name}
                </h3>
                <p className="text-gray-600 mb-2 md:mb-4 text-[10px] md:text-sm leading-snug min-h-[28px] md:min-h-[40px]" data-id="element-204">
                  {plan.description}
                </p>

                <div data-id="element-205">
                  <span className="text-gray-500 line-through text-xs md:text-lg block" data-id="element-206">
                    ${plan.anchorPrice.toLocaleString('es-AR')}
                  </span>
                  <div className="font-serif text-2xl md:text-5xl font-bold text-gold leading-none" data-id="element-207">
                    ${plan.price.toLocaleString('es-AR')}
                  </div>
                </div>
              </div>
            </motion.button>;
      })}
      </div>

      <motion.a key={selectedPlan.id} href={selectedPlan.url} target="_blank" rel="noopener noreferrer" initial={{
      opacity: 0.8,
      scale: 0.98
    }} animate={{
      opacity: 1,
      scale: 1
    }} whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} className="block w-full bg-gold hover:bg-gold-bright text-navy-dark font-bold text-center py-4 md:py-5 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 text-base md:text-lg" data-id="element-208">
        {selectedPlan.id === 'premium' ? <>
            <Star className="inline w-4 h-4 md:w-5 md:h-5 mr-1 fill-navy-dark" data-id="element-209" />
            COMPRAR PACK PREMIUM
          </> : <>💥 COMPRAR AHORA — ${selectedPlan.price.toLocaleString('es-AR')}</>}
      </motion.a>

      <p className="text-center text-xs md:text-sm text-gray-600 mt-2 md:mt-3" data-id="element-210">
        {selectedPlan.id === 'premium' ? 'La opción más elegida por nuestros compradores que quieren el sistema completo' : 'Sistema completo para empezar hoy mismo'}
      </p>
    </div>;
}